
export const dateTypes = [
  {
    label: "Before",
    value: "before"
  },
  {
    label: "On The Day",
    value: "on the day"
  },
  {
    label: "After",
    value: "after"
  }
];
export const datePeriods = [
  {
    label: "Day",
    value: "Day"
  },
  {
    label: "Month",
    value: "Month"
  },
  {
    label: "Year",
    value: "Year"
  }
]

export const recurringTypes = [
  {
    label: "Weekly",
    value: 1,
  },
  {
    label: "Monthly",
    value: 2,
  },
]

export const limitTypes = [
  {
    label: "Equal to",
    value: "="
  },
  {
    label: "Less",
    value: "<"
  },
  {
    label: "Greater",
    value: ">"
  },
]

export const isPersonalOptions = [
  {
    label: "Person",
    value: 1
  },
  {
    label: "Other",
    value: 0
  }
]

export const disableRecurringList = [35, 36, 38, 39, 45, 47]

export const disableRecurringNamesList = ["Anniversary", "Birthday", "Death of Member", "Membership", "Death in family", "Member resignation"]

export const tokenList = ["{{fname}}", "{{nickname}}", "{{spousename}}"]

export const days = [
  { "id": 1, "name": "Sunday" },
  { "id": 2, "name": "Monday" },
  { "id": 3, "name": "Tuesday" },
  { "id": 4, "name": "Wednesday" },
  { "id": 5, "name": "Thursday" },
  { "id": 6, "name": "Friday" },
  { "id": 7, "name": "Saturday" },
  { "id": 8, "name": "All" },
  { "id": 9, "name": "All" }
]